import { useEffect,useState } from 'react'
import api     from '../../services/apiClient'
import Spinner from '../Shared/Spinner'
import Tag     from '../Shared/Tag'

export default function BestPracticeHub() {
  const [docs,setDocs]     = useState([])
  const [filter,setFilter] = useState('all')
  const [loading,setLoading]=useState(true)

  useEffect(()=>{
    api.get('/api/community/best-practices')
       .then(({data})=>setDocs(data))
       .finally(()=>setLoading(false))
  },[])

  const categories = ['all', ...new Set(docs.flatMap(d=>d.tags||[]))]

  const visible = filter==='all' ? docs : docs.filter(d=>d.tags?.includes(filter))

  return (
    <div className="p-unit space-y-unit">
      <div className="flex items-center gap-2 flex-wrap">
        {categories.map(cat=>(
          <button
            key={cat}
            onClick={()=>setFilter(cat)}
            className={`px-3 py-1 rounded-full text-sm capitalize
                        ${filter===cat
                          ?'bg-soft-yellow/70 font-medium'
                          :'hover:bg-soft-yellow/40 text-slate-gray'}`}
          >
            {cat}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><Spinner/></div>
      ) : (
        <ul className="grid gap-unit sm:grid-cols-2 xl:grid-cols-3">
          {visible.map(d=>(
            <li key={d.id} className="border rounded-2xl p-unit hover:bg-soft-yellow/30">
              <h3 className="font-semibold">{d.title}</h3>
              <p className="text-sm line-clamp-3 mb-2">{d.summary}</p>
              <div className="flex flex-wrap gap-1">
                {d.tags?.map(t=><Tag key={t}>{t}</Tag>)}
              </div>
              <a
                href={d.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-2 text-deep-blue underline text-sm"
              >
                Read more →
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
